export default __webpack_public_path__ + "static/screeny-130-gpz-i-6-ca809cc6ffc7d6b9a04251815789775b.jpg";